import styled from "styled-components";

export const Container = styled.div`
  background: white;
  margin: 20px 0px 40px 0px;
`;
